import fileDownload from "js-file-download";
import { useCallback, useEffect, useState } from "react";
import { FaArrowLeftLong } from "react-icons/fa6";
import { IoIosArrowForward } from "react-icons/io";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { ERROR_MSG, IMAGES_PURPOSE } from "../../constants/common";
import { RESET_LOADER, SET_LOADER } from "../../constants/contexConstant";

import {
    mobilePannelTypes,
    panelTypes,
} from "../../constants/proposalConstants";
import {
    ADD_COMMUNE_INVSETMENT,
    ADMIN_FINAL_PROPOSAL_UPDATE,
    CREATE_MEETING_NOTES_ENDPOINT,
    CREATE_REMINDER_ENDPOINT,
    DOWNLOAD_PROPOSAL_DATA_ENDPOINT,
    ESTABLISH_CONNECTION_ENDPOINT,
    FILE_DOCUMENT_UPLOAD_ENDPOINT,
    GET_CREDENTIALS_ENDPOINT,
    GET_INVERTOR_ENDPOINT,
    GET_PLANT_BY_ID_ENDPOINT,
    SALES_PROPOSAL_BASE_ENDPOINT,
    SHARE_PROPOSAL_TO_WHATSAPP_ENDPOINT,
    TEST_CONNECTION_ENDPOINT,
} from "../../constants/routes";
import { useContextState } from "../../context/ContextProvider";
import { generateTimestamp, getMenuItems } from "../../helpers/helpers";
import useFileUploadAndRemove from "../../hooks/useFileUploadAndRemove";
import cn from "../../lib/cn";
import { starCircle, trophyCup } from "../../resources/js/icons";
import request from "../../services/request";
import Container from "../../shared/Container";
import H4 from "../../shared/typography/H4";
import P from "../../shared/typography/P";
import DrawerAndModalWrapper from "../../shared/ui/Drawer/DrawerAndModalWrapper";
import Approve from "./approve";
import SideBar from "./ConsumerProposal/SideBar";
import CommuneInvestmentForm from "./forms/CommuneInvestmentForm";
import CommuneManagerForm from "./forms/CommuneManagerForm";
import FinalClosureForm from "./forms/FinalClosureForm";
import InsightsForm from "./forms/InsightsForm";
import NotesForm from "./forms/NotesForm";
import PlantStatusForm from "./forms/PlantStatusForm";
import ReminderForm from "./forms/ReminderForm";
import ShareLinkForm from "./forms/ShareLinkForm";
import WhatsAppShareForm from "./forms/WhatsAppShareForm";
import ProposalSuccess from "./ProposalSuccess";
import ProposalTable from "./ProposalTable";
import SuccessMsg from "./SuccessMsg";
const LEASE = "Lease";
const PURCHASE = "Purchase";

const columns = ["Admin Name", "Phone Number"];

const ProposalContent = ({
    currentTab,
    currentProposalId,
    proposalData,

    tableData,
    options,
    handleSelectedProposalId,
    connectionType,
    isAnyApproved,
    admins,
    subsidyAmount,
    url,
    handleAdmins,
    solarPlantSize,

    setDis,
    propertyName,
    formData,
    setSubsidyAmount,
    setCurrentTab,
    currentPanelType,
    setCurrentPannelType,
}) => {
    const { state, dispatch } = useContextState();
    const { id } = useParams();

    const [showDrawer, setShowDrawer] = useState(false);

    const menuItems = getMenuItems(state?.user?.roles, isAnyApproved, url);
    const [selectedShare, setSelectedShare] = useState(PURCHASE);
    const [whatsAppLoading, setWhatsAppLoading] = useState(false);
    const [activeItem, setActiveItem] = useState(null);
    const [showApproveModal, setShowApproveModal] = useState(null);
    const [optionLabel, setOptionLabel] = useState("Proposal");
    const [shareSucess, setShareSucess] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [notesFormStep, setNotesFormStep] = useState(1);
    const [notesStep1Data, setNotesStep1Data] = useState({});
    const [showApproved, setShowApprove] = useState(false);

    const [credentials, setCredentials] = useState({});
    const [invertors, setInvertors] = useState([]);
    const [additionalInput, setAdditionalInputs] = useState([
        { adminName: "", adminPhone: "" },
    ]);

    const {
        file,
        setFile,
        uploadedDoc,
        uploading,
        setUploadedDoc,
        handleFileChange,
        removeFile,
    } = useFileUploadAndRemove(
        FILE_DOCUMENT_UPLOAD_ENDPOINT,
        IMAGES_PURPOSE.CUSTOMER_BILL
    );

    const [testConn, setTestConn] = useState(false);
    const handleChangeFileInput = async (e) => {
        await handleFileChange(e);
    };

    const fetchData = async () => {
        try {
            dispatch({ type: SET_LOADER });
            const endpoint = `${GET_PLANT_BY_ID_ENDPOINT}/${id}`;
            const data = await request.authGet({ endpoint });
            handleAdmins(data?.data?.plant?.admins);
            dispatch({ type: RESET_LOADER });
        } catch (error) {
            dispatch({ type: RESET_LOADER });
        }
    };
    const handleQuit = () => {
        setAdditionalInputs([
            { adminName: "", adminPhone: "" /*adminRole: "" */ },
        ]);
    };

    const handleInvite = async () => {
        const modifiedInput = additionalInput.map((input) => ({
            ...input,
            adminPhone: input.adminPhone ? `91${input.adminPhone}` : "",
        }));
        try {
            const endpoint = `${SALES_PROPOSAL_BASE_ENDPOINT}/lease/${id}/enable_investment`;
            dispatch({ type: SET_LOADER });
            await request.authPost({
                endpoint,
                body: modifiedInput,
            });
            fetchData();
            dispatch({ type: RESET_LOADER });
            toast.success("Invite Sent!");
            setShareSucess(true);
        } catch (error) {
            dispatch({ type: RESET_LOADER });
            toast.error("Invite is not Sent");
        }
    };
    const transformedAdmins = admins?.map((admin) => ({
        "Admin Name": admin.name,
        "Phone Number": admin.phone.slice(2),
    }));
    useEffect(() => {}, [shareSucess, currentProposalId]);
    useEffect(() => {
        getCredentials();
        getInverters();
    }, []);

    useEffect(() => {
        setAdditionalInputs([{ adminName: "", adminPhone: "" }]);
    }, [admins]);
    const handleShareToWhatsapp = useCallback(async () => {
        let body = {
            plantId: id,
            proposalId: currentProposalId,
            proposalType: selectedShare.toUpperCase(),
        };
        try {
            setWhatsAppLoading(true);
            let endpoint = SHARE_PROPOSAL_TO_WHATSAPP_ENDPOINT;
            await request.authPost({ endpoint, body });
            setWhatsAppLoading(false);
            toast.success(
                `You have successfully shared ${selectedShare} proposal with proposal id: #${currentProposalId} to Whatsapp`
            );
            setWhatsAppLoading(false);
            setShareSucess(true);

            setSelectedShare(PURCHASE);
        } catch (error) {
            setWhatsAppLoading(false);
            toast.error(typeof error === "string" ? error : ERROR_MSG);

            setSelectedShare(PURCHASE);
        }
    }, [id, currentProposalId, selectedShare]);

    const createMeetingNotes = async (formData) => {
        const timestamp = generateTimestamp(
            formData.date,
            formData.hour,
            formData.minutes
        );
        let fileIds = [];
        if (!formData.isBillNotAvailable) {
            fileIds = uploadedDoc.map((item) => item.file);
        }

        let body =
            formData.visitType === "FRESH"
                ? {
                      plantId: id,
                      visitType: formData.visitType,
                      date: timestamp,
                      isPanelBrandReqired: !formData?.isPanelBrandNotReqired,
                      panelBrand: formData?.panelBrand,
                      isInverterNameRequired:
                          !formData?.isInverterNameNotRequired,
                      inverterName: formData?.inverterName,
                      connectionPhase: formData.connectionPhase,
                      roofType: formData.roofType,
                      isSubsidy: formData.isSubsidy === "yes",
                      hasLoadEnhancement: formData.hasLoadEnhancement === "yes",
                      hasLoanRequirement: formData.hasLoanRequirement === "yes",
                      hasElevatedStructure:
                          formData.hasElevatedStructure === "yes",
                      customerComment: formData.customerComment,
                      isBillAvailable: !formData?.isBillNotAvailable,
                      electricityBillUrl: !formData?.isBillNotAvailable
                          ? fileIds
                          : [],
                  }
                : {
                      plantId: id,
                      visitType: formData.visitType,
                      date: timestamp,
                      followupType: formData.followupType,
                      message: formData.message,
                      actionTaken: formData.actionTaken,
                      proposalStage: formData.proposalStage,
                  };

        try {
            dispatch({ SET_LOADER });
            let endpoint = CREATE_MEETING_NOTES_ENDPOINT;
            await request.authPost({ endpoint, body });
            dispatch({ RESET_LOADER });
            toast.success("Meeting Notes Created Successfully!");
            setShareSucess(true);
            setNotesFormStep(1);
        } catch (error) {
            dispatch({ RESET_LOADER });
            toast.error(typeof error === "string" ? error : ERROR_MSG);
        }
    };

    const createReminder = async (formData) => {
        const timestamp = generateTimestamp(
            formData.date,
            formData.hour,
            formData.minutes
        );
        let body = {
            plantId: id,
            message: formData.message,
            date: timestamp,
        };
        try {
            dispatch({ SET_LOADER });
            let endpoint = CREATE_REMINDER_ENDPOINT;
            await request.authPost({ endpoint, body });
            dispatch({ RESET_LOADER });
            toast.success("Reminder Created Successfully!");
            setShareSucess(true);
        } catch (error) {
            dispatch({ RESET_LOADER });
            toast.error(typeof error === "string" ? error : ERROR_MSG);
        }
    };

    const getCredentials = async () => {
        try {
            dispatch({ SET_LOADER });
            let endpoint = GET_CREDENTIALS_ENDPOINT;
            let response = await request.authGet({
                endpoint,
            });
            dispatch({ type: RESET_LOADER });
            setCredentials(response?.data?.data);
        } catch (error) {
            //toast.error(typeof error === "string" ? error : ERROR_MSG);
            dispatch({ type: RESET_LOADER });
        }
    };

    const handleFinalClosure = async (values) => {
        try {
            dispatch({ SET_LOADER });
            let endpoint = `${ADMIN_FINAL_PROPOSAL_UPDATE}/${id}`;
            let body = {
                isSubsidy: values?.panelType === "dcr",
                finalPrice: values?.finalPrice,
            };
            await request.authPut({ endpoint, body });
            dispatch({ RESET_LOADER });
            toast.success("Successfully updated final closure price");
            setShareSucess(true);
        } catch (error) {
            toast.error(typeof error === "string" ? error : ERROR_MSG);
            dispatch({ RESET_LOADER });
        }
    };

    const getInverters = async () => {
        try {
            dispatch({ SET_LOADER });
            let endpoint = GET_INVERTOR_ENDPOINT;
            let response = await request.authGet({
                endpoint,
            });
            dispatch({ type: RESET_LOADER });
            const formattedData = response?.data?.data?.map((item) => ({
                label: item
                    .replace(/_/g, " ")
                    .toLowerCase()
                    .replace(/\b\w/g, (c) => c.toUpperCase()),
                value: item,
            }));
            setInvertors(formattedData);
        } catch (error) {
            toast.error(typeof error === "string" ? error : ERROR_MSG);
            dispatch({ type: RESET_LOADER });
        }
    };

    const establishConnection = async () => {
        const formData = new FormData();
        formData.append("plantId", id);
        try {
            dispatch({ SET_LOADER });

            let endpoint = ESTABLISH_CONNECTION_ENDPOINT;
            await request.authPost({ endpoint, body: formData });
            dispatch({ RESET_LOADER });
            toast.success("Established Connection Successfully!");
            setShareSucess(true);
        } catch (error) {
            toast.error(typeof error === "string" ? error : ERROR_MSG);
            dispatch({ type: RESET_LOADER });
        }
    };

    const testConnection = async (invertor) => {
        const formData = new FormData();
        formData.append("plantId", id);
        formData.append("inverter", invertor);
        try {
            dispatch({ SET_LOADER });

            let endpoint = TEST_CONNECTION_ENDPOINT;
            await request.authPost({ endpoint, body: formData });
            dispatch({ RESET_LOADER });
            toast.success(" Connection Successfully!");
            setTestConn((prev) => !prev);
        } catch (error) {
            toast.error(typeof error === "string" ? error : ERROR_MSG);
            dispatch({ type: RESET_LOADER });
        }
    };

    const canApproved = () => {
        if (currentTab === 0) {
            return (
                formData?.customerPurchase !== "APPROVED" &&
                formData?.customerPurchase !== "REJECTED"
            );
        } else {
            return (
                formData?.customerLease !== "APPROVED" &&
                formData?.customerLease !== "REJECTED"
            );
        }
    };

    const handleCommuneInvestment = async (values) => {
        try {
            dispatch({ SET_LOADER });
            let endpoint = `${ADD_COMMUNE_INVSETMENT}/${id}`;
            let body = {
                llpName: values?.llpName,
                paymentCollection: values?.paymentCollection,
                bankAccountName: values?.bankAccountName,
                bankAccountNumber: values?.bankAccountNumber,
                bankAccountType: values?.bankAccountType,
                ...(values?.paymentCollection === "PAYMENT_GATEWAY" && {
                    razorpayTransferAccount: values?.razorpayTransferAccount,
                }),
            };

            await request.authPost({ endpoint, body });
            dispatch({ RESET_LOADER });
            toast.success("Successfully Added LLP Details");
            setShareSucess(true);
        } catch (error) {
            toast.error(typeof error === "string" ? error : ERROR_MSG);
            dispatch({ type: RESET_LOADER });
        }
    };

    const renderContent = () => {
        switch (activeItem) {
            case "Reminder":
                return shareSucess ? (
                    <SuccessMsg message="Your Reminder Recorded Successfully" />
                ) : (
                    <ReminderForm
                        onSuccess={(formData) => createReminder(formData)}
                    />
                );
            case "Notes":
                return shareSucess ? (
                    <SuccessMsg message="Meeting Notes Added Successfully" />
                ) : (
                    <NotesForm
                        onSuccess={(formData) => createMeetingNotes(formData)}
                        notesFormStep={notesFormStep}
                        setNotesFormStep={setNotesFormStep}
                        notesStep1Data={notesStep1Data}
                        setNotesStep1Data={setNotesStep1Data}
                        file={file}
                        uploading={uploading}
                        handleFileUpload={handleChangeFileInput}
                        removeFile={removeFile}
                    />
                );
            case "WhatsApp":
                return shareSucess ? (
                    <SuccessMsg message="Successfully shared on WhatsApp" />
                ) : (
                    <WhatsAppShareForm
                        selectedShare={selectedShare}
                        setSelectedShare={setSelectedShare}
                        onShare={handleShareToWhatsapp}
                        loading={whatsAppLoading}
                    />
                );
            case "Investment":
                return shareSucess ? (
                    <SuccessMsg message="Successfully Added LLP Details" />
                ) : (
                    <CommuneInvestmentForm
                        url={url}
                        onSuccess={(values) => handleCommuneInvestment(values)}
                    />
                );

            case "Commune":
                return shareSucess ? (
                    <SuccessMsg message="Successfully Enabled Commune for the Plant" />
                ) : (
                    <CommuneManagerForm
                        onSuccess={() => setShareSucess(true)}
                        currentSlide={currentSlide}
                        setCurrentSlide={setCurrentSlide}
                        additionalInput={additionalInput}
                        setAdditionalInputs={setAdditionalInputs}
                        handleInvite={handleInvite}
                        handleQuit={handleQuit}
                        admins={admins}
                        columns={columns}
                        transformedAdmins={transformedAdmins}
                    />
                );

            case "Insights":
                return shareSucess ? (
                    <SuccessMsg message="Successfully Enabled Solar Insights for the Plant" />
                ) : (
                    <InsightsForm
                        onSuccess={() => establishConnection(true)}
                        credentials={credentials}
                        inverters={invertors}
                        testConn={testConn}
                        testConnection={testConnection}
                    />
                );
            case "FinalClosure":
                return shareSucess ? (
                    <SuccessMsg message="Successfully updated final closure price" />
                ) : (
                    <FinalClosureForm
                        onSuccess={(values) => {
                            handleFinalClosure(values);
                        }}
                    />
                );
            case "ActivateDeactivate":
                return shareSucess ? (
                    <SuccessMsg message="Plant status successfully set" />
                ) : (
                    <PlantStatusForm
                        onSuccess={(values) => setShareSucess((prev) => !prev)}
                    />
                );
            case "ShareLink":
                return <ShareLinkForm url={url} />;
            default:
                return (
                    <ul className="divide-y divide-gray-200">
                        {menuItems.map(({ id, label, icon, type }) => (
                            <li
                                key={id}
                                role="button"
                                disabled={true}
                                className={`flex items-center justify-between p-3 cursor-pointer rounded-md
                                    ${
                                        id === "Approve" && !canApproved()
                                            ? "text-secondary bg-gray-100"
                                            : activeItem === id
                                            ? "bg-blue-100 text-blue-700"
                                            : "hover:bg-gray-100"
                                    }`}
                                onClick={() => handleAdminMenu(id, label)}
                            >
                                <div className="flex items-center gap-2">
                                    <P className="text-xl">
                                        {type === "img" ? (
                                            <img
                                                src={icon}
                                                alt={label}
                                                className="w-2 h-2"
                                            />
                                        ) : (
                                            icon
                                        )}
                                    </P>
                                    <P>{label}</P>
                                </div>
                                <P>
                                    <IoIosArrowForward />
                                </P>
                            </li>
                        ))}
                    </ul>
                );
        }
    };

    const downloadProposalDocument = async () => {
        let basePath = DOWNLOAD_PROPOSAL_DATA_ENDPOINT;

        try {
            dispatch({ type: SET_LOADER });
            let endpoint = `${basePath}/${id}/${currentProposalId}`;
            let res = await request.authPost({
                endpoint,
                checkStatusCode: true,
                body: {
                    type: options[currentTab]?.toLowerCase(),
                    isSubsidy: currentPanelType?.subsidy,
                },
            });
            let file = await res.blob();
            fileDownload(
                file,
                res?.headers?.get("x-custom-filename") || "proposal.pdf"
            );
            dispatch({ type: RESET_LOADER });
        } catch (error) {
            toast.error(typeof error === "string" ? error : ERROR_MSG);
            dispatch({ type: RESET_LOADER });
        }
    };
    const onUpdatePanelType = (item) => {
        setCurrentPannelType(item);
    };

    const handleOnAcceptProposal = () => {
        setShowApprove((prev) => !prev);
    };

    const handleCloseMenu = () => {
        setActiveItem(null);
        setShowDrawer((prev) => !prev);
        setShareSucess(false);
        setNotesFormStep(1);
    };

    const handleAdminMenu = (id, label) => {
        if (id === "Approve") {
            if (canApproved()) {
                setShowApproveModal(true);
                handleCloseMenu();
            }
            return;
        } else if (id === "Upload") {
            handleCloseMenu();
        } else {
            setActiveItem(id);
            setOptionLabel(label);
        }
    };

    return (
        <>
            <Container className="min-w-full lg:bg-white px-0 mx-0 lg:overflow-y-scroll  lg:container lg:min-w-fit xl:px-[10rem] lg:flex lg:justify-center mb-4 lg:mb-0">
                <div className="lg:bg-white   rounded-lg md:items-stretch lg:w-full lg:justify-center  flex flex-col lg:flex-row gap-1.6 ">
                    <Container className="lg:w-[40%] lg:shadow-xl lg:border lg:p-2 lg:rounded-2xl ">
                        <div className="hidden lg:flex w-full my-1">
                            <div className="flex w-full items-center border-b border-b-blue-250">
                                {options.map((option, index) => (
                                    <div
                                        key={option}
                                        role="button"
                                        className={`w-${
                                            options.length === 2
                                                ? "1/2"
                                                : "full"
                                        }`}
                                        onClick={() => setCurrentTab(index)}
                                    >
                                        <P
                                            className={cn(
                                                "text-gray-370 border-b-none flex items-center gap-1",
                                                {
                                                    "text-blue border-b-2 border-b-blue pb-1 font-medium":
                                                        currentTab === index,
                                                }
                                            )}
                                        >
                                            {option}
                                            {option === "Lease" && admins && (
                                                <img
                                                    src={starCircle}
                                                    alt="Lease Enabled"
                                                    className="w-2"
                                                />
                                            )}
                                        </P>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="flex justify-between lg:mt-3  items-start gap-3 lg:block ">
                            <SideBar
                                panels={true}
                                currentProposal={currentProposalId}
                                proposalData={proposalData}
                                onUpdate={handleSelectedProposalId}
                                panelTypes={panelTypes}
                                currentPanelType={
                                    currentPanelType || panelTypes[1]
                                }
                                onUpdatePanelType={onUpdatePanelType}
                                connectionType={connectionType}
                                mobilePannelTypes={mobilePannelTypes}
                            />
                        </div>
                    </Container>
                    <div className="w-full">
                        <ProposalTable
                            currentTab={currentTab}
                            downloadProposalDocument={downloadProposalDocument}
                            selected={currentProposalId}
                            tableData={tableData}
                            options={options}
                            url={url}
                            solarPlantSize={solarPlantSize}
                            setDis={setDis}
                            setSubsidyAmount={setSubsidyAmount}
                            propertyName={propertyName}
                            solarData={formData}
                            setShowDrawer={setShowDrawer}
                            isSubsidy={currentPanelType?.subsidy}
                            subsidyAmount={subsidyAmount}
                            connectionType={connectionType}
                        />
                    </div>
                </div>
            </Container>
            <DrawerAndModalWrapper
                isOpen={showDrawer}
                showClose={false}
                onClose={handleCloseMenu}
                childrenClassName="rounded-t-4"
                modalContentClass="bg-white max-h-[500px] p-2"
                chidrenContainerClass="min-w-full px-0 mx-0 "
                drawerContentClassName="min-h-[85vh]  rounded-t-4 w-full xs:min-h-[85rem] bottom-0 flex flex-col pb-0"
            >
                {notesFormStep === 2 && !shareSucess && (
                    <div
                        role="button"
                        onClick={() => setNotesFormStep(1)}
                        className="sticky top-0 px-2 py-1 z-40 bg-white w-full hidden lg:flex"
                    >
                        <P className="text-xl flex items-center gap-0.5">
                            <FaArrowLeftLong /> GoBack
                        </P>
                    </div>
                )}

                <div
                    className={cn("lg:hidden", {
                        "h-full":
                            (activeItem === "Notes" &&
                                notesFormStep === 2 &&
                                !shareSucess) ||
                            activeItem === "",
                    })}
                >
                    <div
                        className="sticky top-0 z-10 bg-violet-300 flex items-center gap-2 px-3 pt-3 pb-2 rounded-t-2"
                        role="button"
                        onClick={() => {
                            if (shareSucess) {
                                setShareSucess((prev) => !prev);
                                setActiveItem(null);
                                setShowDrawer((prev) => !prev);
                            } else {
                                activeItem && notesFormStep === 1
                                    ? setOptionLabel("Proposal")
                                    : setNotesFormStep(1);
                                activeItem
                                    ? notesFormStep === 1
                                        ? setActiveItem(null)
                                        : setNotesFormStep(1)
                                    : setShowDrawer((prev) => !prev);
                            }
                        }}
                    >
                        <H4 className="text-white text-xl">
                            <FaArrowLeftLong />
                        </H4>
                        <H4 className="text-white">{optionLabel}</H4>
                    </div>
                    <div className="bg-white mt-2 pb-2 h-full overflow-y-auto rounded-t-2 relative bottom-0">
                        {renderContent()}
                    </div>
                </div>

                <div className="hidden lg:block bg-white w-full max-h-[500px] p-2">
                    {renderContent()}
                </div>
            </DrawerAndModalWrapper>

            <DrawerAndModalWrapper
                isOpen={showApproveModal}
                showClose={true}
                onClose={() => setShowApproveModal(false)}
                modalContentClass="bg-white"
                chidrenContainerClass="w-full px-0  "
                modalWidth={
                    showApproved
                        ? ["100%", "100%", "700px"]
                        : ["100%", "100%", "80%"]
                }
                drawerContentClassName="min-h-screen bg-white px-0 rounded-t"
                drawerClassName="z-101"
            >
                {showApproved ? (
                    <ProposalSuccess onUploadReceipt={handleOnAcceptProposal} />
                ) : (
                    <Approve
                        className="h-auto"
                        buttonClass="mb-0"
                        img={trophyCup}
                        showClose={false}
                        minHeightClass="pt-0 h-auto"
                        tableData={[
                            {
                                Description: "Fix Monthly Rental",
                                "Plan Details": 2000,
                            },
                            {
                                Description: "Bank Guarantee",
                                "Plan Details": 30304,
                            },
                            {
                                Description: "Savings on Existing Bills",
                                "Plan Details": 12929,
                            },
                        ]}
                        onApproved={handleOnAcceptProposal}
                        // onSuccess={(formData) => createReminder(formData)}
                    />
                )}
            </DrawerAndModalWrapper>
        </>
    );
};

export default ProposalContent;
